export default __webpack_public_path__ + "static/media/145.5c248bd7.png";